import Beam from '@scene/objects/beam';
import {
  SET_BEAM_SHAPE,
  SET_BEAM_SHIFT_X,
  SET_BEAM_SHIFT_Y,
  RESET_BEAM, 
  SET_BEAM_STATE,
  SET_BEAM_ROTATION,
  SET_BEAM_ROTATE_DIRECTION,
  SET_BEAM_HEIGHT,
  SET_BEAM_LOAD_LG,
  SET_BEAM_LOAD_F,
  SET_BEAM_LOAD_NR,
  SET_BEAM_WEIGHT_P,
  SET_BEAM_TYPE,
  SET_BEAM_OPTIONS
} from '@reducers/options/beam/actions';
import { mergeDeep } from '@services/helper.service';
import { APP_TYPES } from '@config';
import { initState } from '@reducers/selectors/loads';
// import { BRAND } from '@config';
// import { brandList } from './../../../app.values';

const initialState = {
  width: 20,
  height: 5,
  depth: 20,
  type: Beam.types.SQUARE,
  edgeSize: 1,
  rotation: 0,
  isRotateRight: false,
  shift: {
    x: 0,
    y: 0
  },
  color: 0xc4a68b, //BRAND === brandList.Sea ? 0xc4a68b : null,
  shape: null,

  loads: {
    lg: 200,
    loadF: 0,
    loadNr: 0,
    weightP: 0
  }
};

export default (state = JSON.parse(JSON.stringify(initialState)), action) => {
  switch (action.type) {
    case SET_BEAM_SHIFT_X: {
      state.shift.x = action.value;

      return mergeDeep({}, state);
    }
    case SET_BEAM_SHIFT_Y: {
      state.shift.y = action.value;

      return mergeDeep({}, state);
    }
    case SET_BEAM_SHAPE: {
      state.shape = null;
      state.type = Beam.types.SHAPE;

      return mergeDeep({}, state, {
        shape: action.value
      });
    }
    case RESET_BEAM: {
      if (action.appType === APP_TYPES.BRACKET_ATTACHMENT) {
        return mergeDeep({}, initialState, { height: initState[APP_TYPES.BRACKET_ATTACHMENT].l });
      } else {
        return mergeDeep({}, initialState);
      }
    }
    case SET_BEAM_STATE: {
      return action.state;
    }
    case SET_BEAM_HEIGHT: {
      state.height = +action.value;

      return mergeDeep({}, state);
    }
    case SET_BEAM_LOAD_LG: {
      state.loads.lg = action.value;

      return mergeDeep({}, state);
    }
    case SET_BEAM_LOAD_F: {
      state.loads.loadF = action.value;

      return mergeDeep({}, state);
    }
    case SET_BEAM_LOAD_NR: {
      state.loads.loadNr = action.value;

      return mergeDeep({}, state);
    }
    case SET_BEAM_WEIGHT_P: {
      state.loads.weightP= action.value;

      return mergeDeep({}, state);
    }
    case SET_BEAM_ROTATION: {
      state.rotation = action.value;

      return mergeDeep({}, state);
    }
    case SET_BEAM_ROTATE_DIRECTION: {
      state.isRotateRight = action.value === 'right';

      return mergeDeep({}, state);
    }
    case SET_BEAM_TYPE: {
      return mergeDeep({}, state, { type: action.value });
    }
    case SET_BEAM_OPTIONS: {
      return mergeDeep({}, state, action.value);
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options/beam/index.js